import { call, select, takeEvery } from 'redux-saga/effects'

import { FlagFilters } from '../../../models/flags'
import { FLAG_FILTER_TAB_OPTIONS } from '../../../shared/constants/flags'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Flag, Workspace } from '../../lib/toolBoxes/2D'
import {
    resetFlagStatusFilters,
    selectFlagFilters,
    setFlagCategoryFilters,
    setFlagEmailFilters,
    setFlagFilters,
    setFlagJiraStatusFilters,
    setFlagStatusFilters,
} from '../../slices/materialFlags'
import { selectVisibility } from '../../slices/tools'

export function* handleSetActiveFlagFilterTab() {
    const paperManager: PaperManager | null = yield call(managers.get2DManager)

    if (!paperManager) return

    const flagFilters: FlagFilters = yield select(selectFlagFilters)
    const { isMaterialFlagsVisible } = yield select(selectVisibility)

    const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

    const materialFlagsItems: paper.Item[] = yield call(
        workspaceTool.getItemsWithCriteria,
        'data',
        (data) => data.toolName === Flag.NAME
    )

    materialFlagsItems.forEach((flag) => {
        const { type, status, jiraStatusId, categoryId, createdByEmail, isTemporaryGroup } = flag.data

        const typeMatches = flagFilters.tab === FLAG_FILTER_TAB_OPTIONS.ALL || type === flagFilters.tab

        const statusMatches = flagFilters.status.length === 0 || flagFilters.status.includes(status)

        const jiraStatusMatches =
            flagFilters.jiraStatuses.length === 0 || flagFilters.jiraStatuses.includes(jiraStatusId)

        const categoryMatches = flagFilters.categories.length === 0 || flagFilters.categories.includes(categoryId)

        const emailMatches = flagFilters.emails.length === 0 || flagFilters.emails.includes(createdByEmail)

        flag.visible =
            isMaterialFlagsVisible &&
            (isTemporaryGroup || (typeMatches && statusMatches && jiraStatusMatches && categoryMatches && emailMatches))
    })
}

export function* watchForSetActiveFlagFilterTab() {
    yield takeEvery(
        [
            setFlagFilters,
            setFlagStatusFilters,
            setFlagJiraStatusFilters,
            setFlagCategoryFilters,
            setFlagEmailFilters,
            resetFlagStatusFilters,
        ],
        handleSetActiveFlagFilterTab
    )
}
